export default "__VITE_ASSET__CwMifw_a__"